import { createTheme } from '@mui/material/styles';


const theme = createTheme({
    palette: {
      background: {
        default: 'rgb(1, 1, 3)',
      },
      text: {
        primary: 'rgba(240, 240, 240, 0.87)',
        secondary: 'rgb(173, 171, 189)',
      },
    },
    typography: {
      fontFamily: ["Inter", "sans-serif"].join(","),
      fontSize: 20,
      body1: {
        fontSize: '1.2rem',
        lineHeight: 1.2,
      },
      body2: {
        fontSize: '1rem',
        lineHeight: 1.6,
      },
      overline: {
        fontSize: '.8rem',
        lineHeight: 1,
      },
      h1: {
        fontSize: '4.5rem',
        lineHeight: 1.3,
        textShadow: '0 0 8px rgba(255, 255, 255, 0.2), 0 0 2px rgba(255, 255, 255, 0.1)',
      },
      h2: {
        fontSize: '3.5rem',
        lineHeight: 1.4,
      },
      h3: {
        fontSize: '2.75rem',
        lineHeight: 1,
      },
      h4: {
        fontSize: '1.75rem',
        lineHeight: 1,
      },
      h5: {
        fontSize: '1.4rem',
        lineHeight: 1,
      },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(255, 255, 255, 0.02)',
            borderRadius: '20px',
            boxShadow: 'rgba(0, 0, 0, 0.114) 0px 0.602187px 1.08394px -0.416667px, rgba(0, 0, 0, 0.15) 0px 2.28853px 4.11936px -0.833333px, rgba(0, 0, 0, 0.306) 0px 10px 18px -1.25px, rgba(0, 0, 0, 0.58) 0px -1px 1px 0px inset',
            opacity: 1,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            border: '1px solid rgba(255, 255, 255, .04)',
            backdropFilter: 'blur(10px)',
            borderRadius: 10,
            backgroundColor: 'rgba(255, 255, 255, 0.02)',
            boxShadow: `
              rgba(0, 0, 0, 0.125) 0px 0.60219px 0.60219px -0.83333px,
              rgba(0, 0, 0, 0.125) 0px 2.28853px 2.28853px -1.66667px,
              rgba(0, 0, 0, 0.125) 0px 10px 10px -2.5px
            `,
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: 14,
            border: '1px solid rgba(255, 255, 255, .04)',
            backdropFilter: 'blur(10px)',
            borderRadius: 10,
            backgroundColor: 'rgba(255, 255, 255, 0.02)',
            boxShadow: `
              rgba(0, 0, 0, 0.125) 0px 0.60219px 0.60219px -0.83333px,
              rgba(0, 0, 0, 0.125) 0px 2.28853px 2.28853px -1.66667px,
              rgba(0, 0, 0, 0.125) 0px 10px 10px -2.5px
            `,
          },
          arrow: {
            color: 'rgba(255, 255, 255, 0.02)',
            backdropFilter: 'blur(10px)',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            border: 'none',
            boxShadow: 'none',
            backgroundColor: 'transparent',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontSize: "1rem",
            height: "3rem",
            width: "10rem",
            padding: "1px",
            overflow: "hidden",
            position: "relative",
            textShadow: '0 0 8px rgba(255, 255, 255, 0.2), 0 0 2px rgba(255, 255, 255, 0.1)',
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            color: "rgb(173, 171, 189)",
            padding: "1px",
            overflow: "hidden",
            position: "relative",
            backgroundColor: "transparent",
            transition: "color 0.5s ease",
            "&:hover": {
              backgroundColor: "transparent",
            },
            "& svg": {
              transition: "color 0.5s ease",
            },
            "&:hover svg": {
              color: "#FDFDFD"
            },
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            height: 2,
            background: "linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 0.12) 50%, rgba(0, 0, 0, 0) 100%)",
            border: "none",
            width: "100%",
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(255, 255, 255, 0.02)', 
            borderRadius: 10,
            border: '1px solid rgba(255, 255, 255, .04)', 
            backdropFilter: 'blur(10px)',
            boxShadow: `
              rgba(0, 0, 0, 0.125) 0px 0.60219px 0.60219px -0.83333px,
              rgba(0, 0, 0, 0.125) 0px 2.28853px 2.28853px -1.66667px,
              rgba(0, 0, 0, 0.125) 0px 10px 10px -2.5px
            `,
            margin: '16px', 

          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)', 
            },
          },
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(255, 255, 255, 0.02)',
            boxShadow: `
              rgba(0, 0, 0, 0.125) 0px 0.60219px 0.60219px -0.83333px,
              rgba(0, 0, 0, 0.125) 0px 2.28853px 2.28853px -1.66667px,
              rgba(0, 0, 0, 0.125) 0px 10px 10px -2.5px
            `,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            backgroundColor: 'rgba(255, 255, 255, 0.02)',  
            border: '1px solid rgba(255, 255, 255, 0.07)',  
            backdropFilter: 'blur(10px)', 
            boxShadow: `
              rgba(0, 0, 0, 0.125) 0px 0.60219px 0.60219px -0.83333px,
              rgba(0, 0, 0, 0.125) 0px 2.28853px 2.28853px -1.66667px,
              rgba(0, 0, 0, 0.125) 0px 10px 10px -2.5px
            `, 
            borderRadius: '16px', 
            padding: '10px 16px', 
            fontSize: '14px',  
          },
        },
      },
    },
  });

export default theme;
